export default "__VITE_ASSET__qlZlVLWu__"